import { staticFormApiConnectorLegacy } from 'apiConnector/form/static';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, endWith, filter, map, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import { commonFormActions } from 'state/forms/actions/form';
import type { EpicWithThunk } from 'state/state.common';
import { defaultFormReceivedThunk } from 'state/static/staticForm.thunks';
import { workspaceTabCloneCompleted } from 'state/workspaces/workspace.actions';

export function cloneStaticFormEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient }) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_CLONED'),
      filter(action => action.workspace === 'static'),
      mergeMap(
        ({
          oldTabId,
          newTabId,
          clonedNegotiationId,
          workspace,
          tabType,
          productType,
          productSubtype: productSubType,
        }) => {
          const tabRemoved$ = tabRemoved(action$, newTabId, state$);

          return staticFormApiConnectorLegacy(oldHttpClient)
            .cloneForm({ newTabId, clonedNegotiationId, productType, productSubType })
            .pipe(
              takeUntil(tabRemoved$),
              map(
                ({
                  productView: newProductView,
                  blocksMetadata,
                  fieldsMetadata,
                  values,
                  version,
                  negotiationId,
                  actions,
                  quoteQuery,
                  errors,
                  mustForceAdvancedMode,
                  sendWholeFormData,
                  allowedRequests,
                }) =>
                  defaultFormReceivedThunk(
                    newTabId,
                    newProductView,
                    blocksMetadata,
                    fieldsMetadata,
                    values,
                    version,
                    negotiationId,
                    actions,
                    quoteQuery,
                    mustForceAdvancedMode,
                    allowedRequests,
                    errors,
                    sendWholeFormData,
                  ),
              ),
              catchError(error =>
                of(
                  commonFormActions.defaultFormFailed(
                    'static',
                    newTabId,
                    error.message || 'clone failed',
                    error.traceId,
                  ),
                ),
              ),
              timeoutWith(
                timeoutInMillis,
                of(commonFormActions.defaultFormTimeouted('static', newTabId)),
                appScheduler,
              ),
              endWith(workspaceTabCloneCompleted(oldTabId, workspace, tabType)),
            );
        },
      ),
    );
}
